import { render, staticRenderFns } from "./UserAdminPanelContainer.vue?vue&type=template&id=5fe816fa&"
import script from "./UserAdminPanelContainer.vue?vue&type=script&lang=ts&"
export * from "./UserAdminPanelContainer.vue?vue&type=script&lang=ts&"
import style0 from "./UserAdminPanelContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports